import './pos-dialog.scss';

import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { FocusStream } from '@pos/app/scripts/services/focus-streams';
import { Mask } from '@core/app/scripts/services/mask';
import { PosState } from '@pos/app/scripts/services/pos-state';
import { PosUiState } from '@pos/app/scripts/services/pos-ui-state';
import { SalesCalculations } from '@shared/app/scripts/services/sales-calculations';
import { Utility } from '@core/app/scripts/services/utility';
import { FashionCheque } from '@shared/app/scripts/services/fashion-cheque';

/*
 * pos-dialog component.
 */
angular
  .module('posApp')
  .directive(
    'posDialog',
    (
      $filter: ng.IFilterService,
      $log: ng.ILogService,
      displayMessage: DisplayMessage,
      focusStreams: FocusStream,
      fashionCheque: FashionCheque,
      isFiscalReturn,
      isFiscalSale,
      legacy,
      mask: Mask,
      parser,
      pos,
      posReasons,
      posState: PosState,
      posUiState: PosUiState,
      salesCalculations: SalesCalculations,
      translate: ng.translate.ITranslateService,
      utility: Utility,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./pos-dialog.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate;

        $scope.posReasons = posReasons;
        $scope.dialog = posUiState.dialog;
        $scope.dialogInputFocus$ = focusStreams.input$;

        /*
         * Reset selected discount reason to its default value
         */
        function resetSelectedReason() {
          if (posReasons.discount && posReasons.discount.length > 0) {
            posUiState.dialog.reason = posReasons.discount[0];
          } else {
            posUiState.dialog.reason = '';
          }
        }

        // edit article list: eg change a price of an article (or: the OK button)
        $scope.editArticleList = () => {
          //Must scan article first
          if (pos.transaction.receipt.length === 0) {
            displayMessage.message($translate.instant('ScanAnArticle'));
            return;
          }

          //Selected line must be in list
          if (!pos.transaction.receipt[posUiState.selectedLine]) {
            $log.error(
              'Selected Line: ' + posUiState.selectedLine + ' not in list!',
            );
            return;
          }

          //Validate the entry as numeric
          if (!posUiState.dialog.inputValue) {
            posUiState.dialog.inputValue = '0';
          }
          const newval = String(posUiState.dialog.inputValue).replace(',', '.');
          try {
            posUiState.dialog.inputValue = parser.evaluate(newval);
          } catch (err) {
            displayMessage.message($translate.instant('IncorrectEntry'));
            return;
          }

          // change article list object methods
          const editarticlelist = {
            changePrice: function () {
              $log.log('change price');
              let i;
              let q;

              const list = posUiState.selected;
              const maxList = list.length;

              if (maxList === 0) {
                return;
              }

              //no price change for cashback coupons
              if (list[0].type == 'C') {
                return;
              }

              let totalNettPrice = 0;
              let amount = utility.round2(
                parseFloat(posUiState.dialog.inputValue),
              );
              for (i = 0; i < maxList; i++) {
                if (list[i].category == 'barcode') {
                  //math.abs is used to accomedate Retour
                  totalNettPrice += list[i].nettPrice * Math.abs(list[i].qty);
                }
              }
              let discount, newPrice, diff;
              if (totalNettPrice !== 0) {
                const calc = 1 - amount / totalNettPrice;
                //discount of individual articles added together (renamed from totalDiscount to prevent confusion with transaction.totalDiscount)
                let totalLineDiscount = 0;
                for (q = 0; q < maxList; q++) {
                  if (list[q].category == 'barcode') {
                    discount = calc * list[q].nettPrice;
                    newPrice = utility.round2(list[q].nettPrice - discount);
                    list[q].price = newPrice;
                    list[q].changeDisc = true;
                    if (list[q].nettPrice < newPrice) {
                      list[q].nettPrice = newPrice;
                    }
                    totalLineDiscount += newPrice * Math.abs(list[q].qty);
                    //Add discount reason on change price SWUI-1035
                    list[q].reason = posUiState.dialog.reason;
                  } else {
                    list[q].price = amount;
                    //prevent diff
                    totalLineDiscount = amount;
                  }
                }
                diff = amount - totalLineDiscount;
              } else {
                //giving a price to 0 priced items
                let quantity = 0;
                for (i = 0; i < maxList; i++) {
                  quantity += list[i].qty;
                }
                if (quantity < 0) {
                  quantity = -quantity;
                }
                if (quantity === 0) {
                  quantity = 1;
                }

                //coupons, only one of those can be selected at a time.
                const coupon = pos.transaction.receipt[posUiState.selectedLine];
                if (coupon.category != 'barcode') {
                  if (amount < 0) {
                    displayMessage.message(
                      $translate.instant('Negative Not Allowed'),
                    );
                    amount = 0;
                  } else if (coupon.category == 'storecredit') {
                    if (amount > pos.transaction.customer.storecredit) {
                      displayMessage.message(
                        $translate.instant('Maximum Input Exceeded'),
                      );
                      amount = 0;
                    }
                  } else if (coupon.type == ' ' && coupon.value >= amount) {
                    const diffValue = coupon.value - amount;
                    pos.transaction.couponDiscount -= diffValue;
                    pos.transaction.totalDiscount -= diffValue;
                    coupon.value = amount;
                    coupon.articleDescription =
                      $translate.instant('Value') +
                      ': ' +
                      $filter('currency')(amount);
                    return;
                  } else if (
                    coupon.type == 'U' &&
                    fashionCheque.validateCode(coupon.couponNr)
                  ) {
                    // change price of a fashion cheque
                    let couponValue = coupon.couponBalance;
                    if (amount > couponValue) {
                      displayMessage.message(
                        $translate.instant('Maximum Input Exceeded'),
                      );
                      return;
                    } else if (amount <= 0) {
                      displayMessage.message(
                        $translate.instant('NoNegativeOrZero'),
                      );
                      return;
                    } else {
                      coupon.price = amount;
                      coupon.nettPrice = amount;
                      coupon.changeDisc = true;
                    }
                  } else if (coupon.type != 'I' && coupon.price < amount) {
                    displayMessage.showLoading();

                    const correctPrice = (response) => {
                      let couponValue = response.value;

                      couponValue = couponValue / 100;
                      if (amount > couponValue) {
                        displayMessage.message(
                          $translate.instant('Maximum Input Exceeded'),
                        );
                        amount = couponValue;
                      }
                      //type K stores the value in .value instead of price
                      if (coupon.type == ' ') {
                        const diffValue = coupon.value - amount;
                        pos.transaction.couponDiscount -= diffValue;
                        pos.transaction.totalDiscount -= diffValue;
                        coupon.value = amount;
                        coupon.articleDescription =
                          $translate.instant('Value') +
                          ': ' +
                          $filter('currency')(amount);
                      } else {
                        coupon.price = amount;
                        coupon.nettPrice = amount;
                      }
                      mask.hide();
                      pos.updateTransaction();
                    };
                    let count = 0;
                    const couponError = () => {
                      //Retry once
                      if (count == 1) {
                        const t = setTimeout(() => {
                          $log.log('Retrying failed coupon');
                          count++;

                          legacy
                            .getCoupon(coupon.couponNr)
                            .then(correctPrice, couponError);

                          clearTimeout(t);
                        }, 2000);
                        return;
                      }
                      mask.hide();

                      displayMessage.message(
                        $translate.instant('ErrorScanningCoupon', {
                          coupon,
                        }),
                      );
                    };

                    legacy
                      .getCoupon(coupon.couponNr)
                      .then(correctPrice, couponError);

                    return;
                  }
                }

                newPrice = utility.round2(amount / quantity);
                diff = amount - newPrice * quantity;
                for (i = 0; i < maxList; i++) {
                  list[i].price = newPrice;
                  list[i].nettPrice = newPrice;
                  list[i].changeDisc = true;
                }
              }
              if (diff !== 0) {
                if (Math.abs(list[list.length - 1].qty) > 1) {
                  //find where x: list[index] == pos.transaction.receipt[x]
                  const receipt = pos.transaction.receipt;
                  i = _.indexOf(receipt, list[list.length - 1]);
                  salesCalculations.splitReceiptLine(receipt, i);
                }
                list[list.length - 1].price += diff;
              }
            },
            changeQty: function () {
              const qty = parseInt(posUiState.dialog.inputValue);
              if (
                pos.transaction.receipt[posUiState.selectedLine].category !=
                'barcode'
              ) {
                return;
              }
              if (pos.config.acls.pos_return || qty >= 0) {
                pos.transaction.receipt[posUiState.selectedLine].qty = qty;
              }
            },
            changeDiscount: function () {
              const line = pos.transaction.receipt[posUiState.selectedLine];
              line.changeDisc = true;
              line.reason = posUiState.dialog.reason;
              //rounding priority on discount.
              line.price =
                line.nettPrice -
                utility.round2(parseFloat(posUiState.dialog.inputValue));
            },
            changeDiscountPercentage: function () {
              const line = pos.transaction.receipt[posUiState.selectedLine];
              line.changeDisc = true;
              line.reason = posUiState.dialog.reason;
              //rounding priority on discount.
              line.price =
                line.nettPrice -
                utility.round2(
                  (line.nettPrice * parseFloat(posUiState.dialog.inputValue)) /
                    100,
                );
            },
          };

          // run callback function
          editarticlelist[posUiState.dialogCallback]();

          posUiState.resetDialog();
          pos.updateTransaction();
        };

        /*
         * Limit the possible values in the input field on the POS page, depending on the callback name.
         */
        const inputValueRulesList = {
          changeQty: function (val) {
            let maxValue = 9999,
              minValue = -9999;

            if (isFiscalReturn()) {
              maxValue = 0;

              if (
                posState.returnTransaction.receipt &&
                posState.returnTransaction.receipt[posUiState.selectedLine]
              ) {
                minValue =
                  -posState.returnTransaction.receipt[posUiState.selectedLine]
                    .qty;
              }
            }

            if (isFiscalSale()) {
              minValue = 0;
            }

            val = parseFloat(val);

            if (val > maxValue || val < minValue) {
              posUiState.dialog.inputValue = 0;
              displayMessage.message(
                $translate.instant('Maximum Input Exceeded'),
              );
            }
          },
          changePrice: function (val) {
            val = parseFloat(val);
            if (val > 999999 || val < 0) {
              posUiState.dialog.inputValue = 0;
              if (val > 999999) {
                displayMessage.message(
                  $translate.instant('Maximum Input Exceeded'),
                );
              } else {
                displayMessage.message(
                  $translate.instant('Negative Not Allowed'),
                );
              }
            }
          },
          changeDiscountPercentage: function (val) {
            val = parseFloat(val);
            if (val > 100) {
              posUiState.dialog.inputValue = 0;
              displayMessage.message(
                $translate.instant('Maximum Input Exceeded'),
              );
            }
            if (val < 0) {
              posUiState.dialog.inputValue = 0;
              displayMessage.message(
                $translate.instant('Negative Not Allowed'),
              );
            }
          },
          changeDiscount: function (val) {
            val = parseFloat(val);
            if (pos.transaction.receipt[posUiState.selectedLine]) {
              if (
                val > pos.transaction.receipt[posUiState.selectedLine].nettPrice
              ) {
                posUiState.dialog.inputValue = 0;
                displayMessage.message(
                  $translate.instant('Maximum Input Exceeded'),
                );
              }
            }
            if (val < 0) {
              posUiState.dialog.inputValue = 0;
              displayMessage.message(
                $translate.instant('Negative Not Allowed'),
              );
            }
          },
        };

        $scope.validateDialogInput = () => {
          if (posUiState.dialogCallback && posUiState.dialog.inputValue) {
            let input = String(posUiState.dialog.inputValue);
            input = input.replace(',', '.');
            if (input == '0-') {
              input = '-';
              posUiState.dialog.inputValue = '-';
            }

            //see if input is a number
            if (isNaN(input) && input != '-') {
              posUiState.dialog.inputValue = 0;
              displayMessage.message($translate.instant('IncorrectEntry'));
            }

            if (inputValueRulesList[posUiState.dialogCallback]) {
              inputValueRulesList[posUiState.dialogCallback](input);
            }
          }
        };
      },
    }),
  );
